__turbopack_context__.v({
  "bruketIWiaredApp": "icWbdG_bruketIWiaredApp",
  "brutaleApp": "icWbdG_brutaleApp",
  "butchersMarketApp": "icWbdG_butchersMarketApp",
  "cartDrawerOpen": "icWbdG_cartDrawerOpen",
  "cornerApp": "icWbdG_cornerApp",
  "footer": "icWbdG_footer",
  "footerBrand": "icWbdG_footerBrand",
  "gronaLundApp": "icWbdG_gronaLundApp",
  "heatApp": "icWbdG_heatApp",
  "kafeMagasinetApp": "icWbdG_kafeMagasinetApp",
  "keemchiApp": "icWbdG_keemchiApp",
  "klappenBagerietApp": "icWbdG_klappenBagerietApp",
  "klappenToppstuganApp": "icWbdG_klappenToppstuganApp",
  "leftLinksContainer": "icWbdG_leftLinksContainer",
  "linksContainer": "icWbdG_linksContainer",
  "linksRow": "icWbdG_linksRow",
  "lunchboxApp": "icWbdG_lunchboxApp",
  "lundsKommunApp": "icWbdG_lundsKommunApp",
  "morenoPizzaApp": "icWbdG_morenoPizzaApp",
  "nordrestAxisApp": "icWbdG_nordrestAxisApp",
  "olandschokladApp": "icWbdG_olandschokladApp",
  "orderingTagLine": "icWbdG_orderingTagLine",
  "primaryLeftContainer": "icWbdG_primaryLeftContainer",
  "primaryRow": "icWbdG_primaryRow",
  "rightLinksContainer": "icWbdG_rightLinksContainer",
  "secondaryRow": "icWbdG_secondaryRow",
  "strandgatanApp": "icWbdG_strandgatanApp",
  "tacosAndTequilaApp": "icWbdG_tacosAndTequilaApp",
  "versionText": "icWbdG_versionText",
  "whiteLabeled": "icWbdG_whiteLabeled",
});
